
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import moment from "moment";

@Component
export default class FeedbackCard extends Vue {
  origin: any = window.location.origin;
  @Prop() cardData: any;
  @Prop() activeIndex: String;
  // 点击跳转到详情
  handleClickToDetail(cardData: any) {
    return `${origin}/feedback/detail?FeedbackGUID=${cardData.FeedbackGUID}&TypeEnum=${cardData.TypeEnum}&activeIndex=${this.activeIndex}`
  }

  /**
   * 处理反馈类型
   * @param TypeEnum(1:产品咨询;2:产品建议;3:产品BUG)
   */
  getTypeEnum(type: number) {
    let typeEnum = "";
    switch (type) {
      case 1:
        typeEnum = "产品咨询";
        break;
      case 2:
        typeEnum = "产品建议";
        break;
      case 3:
        typeEnum = "产品BUG";
        break;
    }

    return typeEnum;
  }

  /**
   * 获取反馈类型的样式
   */
  getTypeEnumStyle(type: number) {
    let typeEnumStyle = {};
    switch (type) {
      case 1:
        typeEnumStyle = { color: "#67C23A" };
        break;
      case 2:
        typeEnumStyle = { color: "#E6A23C" };
        break;
      case 3:
        typeEnumStyle = { color: "#F56C6C" };
        break;
    }

    return typeEnumStyle;
  }

  /**
   * 处理反馈状态
   * @param StatusEnum(1:待处理;2:处理中;3:已关闭;4:规划中;5:已兑现)
   */
  getStatusEnum(type: number) {
    let statusEnum = "";
    switch (type) {
      case 1:
        statusEnum = "待处理";
        break;
      case 2:
        statusEnum = "处理中";
        break;
      case 3:
        statusEnum = "已关闭";
        break;
      case 4:
        statusEnum = "规划中";
        break;        
      case 5:
        statusEnum = "已兑现";
        break;          
    }    

    return statusEnum;
  }

  /**
   * 获取反馈状态的样式
   */
  getStatusEnumStyle(type: number) {
    let statusEnumStyle = {};
    switch (type) {
      case 1:
        statusEnumStyle = {
          color: "#529FFD",
          bgColor: "rgba(82,159,253,0.1)",
        };
        break;
      case 2:
        statusEnumStyle = {
          color: "#67C23A",
          bgColor: "rgba(103,194,58,0.1)",
        };
        break;
      case 3:
        statusEnumStyle = {
          color: "#C0C4CC",
          bgColor: "rgba(192,196,204,0.1)",
        };
        break;
      case 4:
        statusEnumStyle = {
          color: "#8B4513",
          bgColor: "#FFD700",
        };
        break;    
      case 5:
        statusEnumStyle = {
          color: "#8B4513",
          bgColor: "#FFD700",
        };
        break;             
    }

    return statusEnumStyle;
  }

  /**
   * 获取解决结果的样式
   */
  getSolveResultStyle(result: string) {
    let solveResultStyle = {};
    if (result === "不处理") {
      solveResultStyle = { color: "#F56C6C" };
    } else {
      solveResultStyle = { color: "#303133" };
    }

    return solveResultStyle;
  }

  // 时间转换
  setTime(time: string) {
    return time ? moment(time).format("YYYY-MM-DD") : "--";
  }
  /**
   * 跳转到满意度页面
   * */
  satis(val: any,view:string) {
    this.$router.push({
      path: "/feedback/satisfaction",
      query: {
        FeedbackGUID: val.FeedbackGUID,
        FeedbackDetailGUID: val.FeedbackDetailsGUID,
        TypeEnum: val.TypeEnum,
        FromType: "List",
        view: view,
      },
    });
  }
}
